import React from 'react';

/**
 * Magic Forest logo mark SVG - UFO with light beam and tree
 * Cropped viewBox to focus on the logo content
 * UFO with white/light gray fill and dark outlines for contrast
 */
export function LogoMark({ className = '', style = {} }) {
  return (
    <svg
      viewBox="125 115 362 530"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Magic Forest logo"
    >
      <defs>
        <style>
          {`
            .mf-dark { fill: #0F170E; }
            .mf-light { fill: #ECECEC; }
            .mf-white { fill: #EDEDED; }
            .mf-ufo-outer { fill: #D8D8D8; stroke: #1a1a1a; stroke-width: 2; }
            .mf-ufo-inner { fill: #E8E8E8; stroke: #1a1a1a; stroke-width: 2.5; }
            .mf-ufo-dome { fill: #FFFFFF; stroke: #1a1a1a; stroke-width: 3; stroke-linejoin: round; stroke-miterlimit: 10; }
            .mf-ufo-top { fill: #F0F0F0; stroke: #1a1a1a; stroke-width: 2; }
            .mf-ufo-base { fill: #C0C0C0; stroke: #1a1a1a; stroke-width: 2; }
          `}
        </style>
      </defs>
      <g id="LOGO">
        <g id="Layers">
          {/* UFO3 White - outer ring highlight */}
          <path className="mf-ufo-outer" d="M178.62,185.03c31.26-2.73,80.05-3.91,127.26-3.83c47.21-0.08,96,1.09,127.26,3.83
            c14.44,1.26,26.66,2.48,36.01,3.96c1.08,0.17,1.44-1.5,0.41-1.88c-22.73-8.32-55.32-14.47-73.64-17.85
            c-33.86-6.23-106.43-12.13-197.44,3.28c-27.2,4.61-45.24,9.8-57.17,14.81c-0.95,0.4-0.57,1.94,0.44,1.78
            C151.2,187.59,163.73,186.33,178.62,185.03"/>
          {/* UFO3 - outer ring */}
          <path className="mf-ufo-inner" d="M170.84,188.64c33.17-2.9,84.95-4.15,135.06-4.06c50.1-0.09,101.89,1.16,135.06,4.06
            c15.32,1.34,28.3,2.64,38.22,4.2c1.15,0.18,1.53-1.59,0.43-2c-24.13-8.83-58.71-15.36-78.16-18.94
            c-35.94-6.61-112.95-12.87-209.54,3.48c-28.86,4.89-48.01,10.4-60.67,15.72c-1.01,0.42-0.61,2.06,0.46,1.89
            C141.74,191.36,155.04,190.02,170.84,188.64"/>
          {/* UFO2 - middle dome */}
          <path className="mf-ufo-dome" d="M370.56,159.84c-1.1-1.57-2.31-3.2-3.64-4.86c-0.4-0.5-0.97-0.79-1.57-0.89
            c-17.51-2.76-36.38-3.99-59.88-3.69c-17.91,0.22-37.56,1.09-58.99,4.67c-0.55,0.09-1.07,0.37-1.43,0.83
            c-1.26,1.68-2.41,3.33-3.43,4.9c-0.4,0.62,0.06,1.46,0.76,1.37c22.85-2.82,44.04-4.1,63.09-4.33c25.71-0.32,47.54,1.24,64.34,3.41
            C370.52,161.34,370.99,160.46,370.56,159.84"/>
          {/* UFO1 White - top dome highlight */}
          <path className="mf-ufo-top" d="M358.98,148.45c0.78,0.11,1.2-0.97,0.62-1.54C347.94,135.53,330.48,125,305.88,125
            c-25.33,0-42.74,11.17-54.05,22.92c-0.56,0.58-0.12,1.61,0.65,1.52c19.23-2.39,37.23-4.65,53.62-4.83
            C326.34,144.38,344.2,146.44,358.98,148.45"/>
          {/* UFO1 - top dome */}
          <path className="mf-ufo-top" d="M359.6,149.1c0.78,0.1,1.21-0.87,0.62-1.38C348.48,137.48,330.92,128,306.15,128
            c-25.49,0-43.01,10.05-54.4,20.63c-0.56,0.52-0.12,1.45,0.66,1.37c19.35-2.15,37.47-4.18,53.96-4.35
            C326.75,145.44,344.72,147.29,359.6,149.1"/>
          {/* Ray (light beam) */}
          <path className="mf-white" d="M345,227l101.9,376.83c0,0,1.82,8.38-10.88,12.64c-27.04,9.08-61.36,15.6-129.66,15.6
            c-64.26,0-102.62-6.52-129.66-15.6c-12.7-4.26-10.88-12.64-10.88-12.64L267,227C267.19,225.88,344.81,225.88,345,227z"/>
          {/* Tree */}
          <path className="mf-dark" d="M252.06,468.42c-13.29,11.38-26.17,16.31-25.82,20.48c0.35,4.17,6.23,7.21,16.02,6.45
            c3.81-0.3,6.88-0.82,9.21-1.35c1.8-0.41,3.08,1.84,1.93,3.4c-3.43,4.63-9.97,10.96-17.49,17.99
            c-12.59,11.76-25.82,14.48-24.77,20.55c1.05,6.07,8.83,7.07,14.34,7.2c7.7,0.19,10.68-1.16,13.23,0.88
            c0.95,0.76-1.69,5.57,2.16,9.36c3.85,3.79,11.14,4.17,20.08-1.9c4.98-3.38,7.84-5.7,9.4-7.09c0.69-0.62,1.73-0.17,1.86,0.79
            c0.47,3.73,1.99,10.51,6.79,10.97c4.46,0.43,9.09-3.54,11.64-6.19c0.74-0.77,2.01-0.17,1.93,0.94
            c-2.41,31.48-4.18,38.44-6.36,41.11c-3.3,4.06-10.66,4.63-29.24,5.42c-24.65,1.05-61.61,2.8-82.84,5.5
            c-1.65,0.21-2.44,2.3-1.41,3.71c1.29,1.76,3.79,3.62,7.2,4.8c25.9,8.95,64.92,14.56,126.45,14.56
            c65.41,0,100.56-5.61,126.45-14.56c3.25-1.12,5.75-2.94,7.07-4.69c1.13-1.5,0.25-3.76-1.52-3.99
            c-21.13-2.72-58.32-4.28-83.17-5.33c-18.58-0.79-25.95-1.36-29.24-5.42c-2.17-2.68-3.95-9.63-6.36-41.11
            c-0.08-1.1,1.19-1.7,1.93-0.94c2.55,2.65,7.18,6.62,11.64,6.19c4.25-0.41,5.93-5.78,6.58-9.6c0.26-1.54,1.95-2.23,3.1-1.26
            c1.68,1.42,4.33,3.46,8.36,6.19c8.95,6.07,16.23,5.69,20.08,1.9c3.85-3.79,1.21-8.6,2.16-9.36c2.55-2.04,5.53-0.7,13.23-0.88
            c5.51-0.13,13.29-1.14,14.34-7.2c1.05-6.07-12.18-8.79-24.77-20.55c-8.72-8.14-15.85-15.63-18.94-19.98
            c-0.66-0.93,0.13-2.25,1.18-1.96c2.44,0.69,6.24,1.51,11.4,1.91c9.79,0.76,15.68-2.28,16.03-6.45c0.35-4.17-12.53-9.1-25.82-20.48
            c-9.19-7.86-15.86-15.91-19.11-20.13c-0.7-0.91,0.05-2.26,1.11-2.01c2.34,0.55,5.73,0.27,9.61,0.07
            c7.34-0.38,13.57-1.58,14.63-5.86c1-4.05-8.33-10-20.92-21.75c-8.29-7.74-13.55-15.2-16.17-19.94c-0.89-1.6,0.44-3.57,2.12-3.15
            c5.59,1.42,14.84,3.81,15.82,0.1c1.4-5.31-21.17-21.25-31.23-42.62c-5.67-12.04-6.54-24.82-9.7-24.82c-0.05,0-0.11,0.01-0.16,0.02
            c-0.05-0.01-0.1-0.02-0.16-0.02c-3.17,0.01-4.03,12.78-9.7,24.82c-10.06,21.36-32.63,37.31-31.23,42.62
            c0.98,3.71,10.23,1.32,15.82-0.1c1.68-0.43,3.01,1.54,2.12,3.15c-2.62,4.75-7.88,12.2-16.17,19.94
            c-12.59,11.76-21.92,17.71-20.92,21.75c1.05,4.28,7.28,5.48,14.63,5.86c3.88,0.2,7.27,0.49,9.61-0.07
            c1.06-0.25,1.81,1.1,1.11,2.01C267.92,452.51,261.24,460.55,252.06,468.42"/>
          {/* White bottom (UFO base reflection) */}
          <path className="mf-ufo-outer" d="M432.63,189.99c-31.12-2.72-79.61-3.9-126.63-3.83c-47.01-0.07-95.51,1.1-126.63,3.83
            c-50.94,4.46-73.93,7.44-41.07,24.79c21.51,11.36,67.9,22.42,109.5,29c0.77,0.12,1.54-0.27,1.91-1.01
            c4.26-8.43,27.79-14.66,56.28-14.75c28.5,0.09,52.02,6.31,56.28,14.75c0.37,0.74,1.14,1.13,1.91,1.01
            c41.6-6.58,87.99-17.64,109.51-29C506.56,197.42,483.56,194.44,432.63,189.99"/>
          {/* UFO base shadow */}
          <path className="mf-ufo-base" d="M426.83,193.15c-29.69-2.6-75.97-3.72-120.83-3.65c-44.86-0.07-91.14,1.05-120.83,3.65
            c-48.6,4.25-70.55,7.1-39.19,23.65c20.53,10.84,64.8,21.39,104.49,27.67c0.73,0.12,1.47-0.25,1.83-0.96
            c4.07-8.05,26.51-13.99,53.71-14.07c27.19,0.09,49.64,6.03,53.71,14.07c0.36,0.7,1.09,1.08,1.83,0.96
            c39.7-6.28,83.97-16.83,104.49-27.67C497.38,200.25,475.44,197.41,426.83,193.15"/>
          {/* Round white bottom (ellipse under UFO) */}
          <ellipse className="mf-white" cx="306" cy="240" rx="55" ry="10"/>
        </g>
      </g>
    </svg>
  );
}
